/**
 * Legal URL Helper Utility
 * Handles opening legal policy URLs consistently across native (Capacitor) and web platforms
 */

/**
 * Opens a legal URL (Privacy Policy or Terms of Service) in the appropriate browser
 * @param {string} url - The URL to open
 */
export const openLegalUrl = async (url) => {
  // Check if running in Capacitor (native app)
  if (window.Capacitor && window.Capacitor.isNativePlatform()) {
    try {
      // Dynamic import - @capacitor/browser is optional and only needed for native builds
      // webpack will warn if not installed, but code will work fine with fallback
      // Suppress webpack warning for optional dependency
      // eslint-disable-next-line import/no-unresolved
      // @ts-ignore - Optional dependency, fallback handled below
      const browserModule = await import(/* webpackIgnore: true */ '@capacitor/browser').catch(() => null);
      
      if (browserModule && browserModule.Browser && browserModule.Browser.open) {
        await browserModule.Browser.open({ url });
        return;
      }
    } catch (error) {
      // Fallback if import fails (package not installed)
      // This is expected when running on web without @capacitor/browser installed
    }
  }
  
  // Web fallback or if Capacitor browser is not available
  window.open(url, '_blank', 'noopener,noreferrer');
};

